import { AuthKeys, AuthState } from '../../state/reducers/authReducer'

export const getUserSignIn = (state: { auth: AuthState }) =>
  state.auth[AuthKeys.userSignIn]
